/* Slide transition CSS keyframes & object entrance animation runner */

export const TRANSITION_CSS = `
@keyframes st-fade{from{opacity:0}to{opacity:1}}
@keyframes st-slide-left{from{transform:translateX(100%)}to{transform:translateX(0)}}
@keyframes st-slide-right{from{transform:translateX(-100%)}to{transform:translateX(0)}}
@keyframes st-slide-up{from{transform:translateY(100%)}to{transform:translateY(0)}}
@keyframes st-slide-down{from{transform:translateY(-100%)}to{transform:translateY(0)}}
@keyframes st-zoom-in{from{transform:scale(.5);opacity:0}to{transform:scale(1);opacity:1}}
@keyframes st-zoom-out{from{transform:scale(1.5);opacity:0}to{transform:scale(1);opacity:1}}
`;

const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
const easeOutBounce = (t) => {
  const n = 7.5625, d = 2.75;
  if (t < 1 / d) return n * t * t;
  if (t < 2 / d) { const t2 = t - 1.5 / d; return n * t2 * t2 + 0.75; }
  if (t < 2.5 / d) { const t2 = t - 2.25 / d; return n * t2 * t2 + 0.9375; }
  const t2 = t - 2.625 / d;
  return n * t2 * t2 + 0.984375;
};

const getFrames = (type, o) => {
  switch (type) {
    case 'fade-in': return [{ opacity: 0 }, { opacity: o.opacity }];
    case 'slide-in-left': return [{ left: o.left - 300, opacity: 0 }, { left: o.left, opacity: o.opacity }];
    case 'slide-in-right': return [{ left: o.left + 300, opacity: 0 }, { left: o.left, opacity: o.opacity }];
    case 'slide-in-bottom': return [{ top: o.top + 300, opacity: 0 }, { top: o.top, opacity: o.opacity }];
    case 'zoom-in': return [{ scaleX: 0.01, scaleY: 0.01, opacity: 0 }, { scaleX: o.scaleX, scaleY: o.scaleY, opacity: o.opacity }];
    case 'bounce': return [{ top: o.top - 100, opacity: 0 }, { top: o.top, opacity: o.opacity }];
    case 'spin': return [{ angle: o.angle - 360, opacity: 0 }, { angle: o.angle, opacity: o.opacity }];
    default: return null;
  }
};

export const runObjectAnimations = (canvas) => {
  if (!canvas) return;
  canvas.getObjects().forEach((obj) => {
    const type = obj.animationType;
    if (!type || type === 'none') return;
    const dur = obj.animationDuration || 500;
    const delay = obj.animationDelay || 0;
    const ease = type === 'bounce' ? easeOutBounce : easeOutCubic;

    const orig = {
      left: obj.left, top: obj.top, opacity: obj.opacity ?? 1,
      scaleX: obj.scaleX ?? 1, scaleY: obj.scaleY ?? 1, angle: obj.angle ?? 0,
    };
    const frames = getFrames(type, orig);
    if (!frames) return;
    const [from, to] = frames;
    const keys = Object.keys(to);

    obj.set(from);
    canvas.renderAll();

    setTimeout(() => {
      const t0 = performance.now();
      const tick = (now) => {
        const p = Math.min((now - t0) / dur, 1);
        const e = ease(p);
        const props = {};
        keys.forEach((k) => { props[k] = from[k] + (to[k] - from[k]) * e; });
        obj.set(props);
        obj.setCoords();
        canvas.requestRenderAll();
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, delay);
  });
};

/** Build the CSS animation value string for a slide transition */
export const getTransitionAnimation = (transition) => {
  if (!transition?.type || transition.type === 'none') return '';
  return `st-${transition.type} ${transition.duration || 500}ms ease forwards`;
};
